var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInformationCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.067 4.865A.889.889 0 0 0 8.2 4a.889.889 0 0 0-.866.866.85.85 0 0 0 .866.867.85.85 0 0 0 .867-.867Zm-1.845 6.467h2.223c.333 0 .555-.157.555-.472 0-.314-.222-.524-.555-.524H9c-.055 0-.111-.053-.111-.105V7.714c0-.577-.5-1.049-1.111-1.049h-.556c-.333 0-.555.21-.555.525 0 .314.222.524.555.524h.445c.055 0 .11.052.11.105v2.36c0 .052-.055.104-.11.104h-.445c-.333 0-.555.21-.555.525 0 .314.222.524.555.524Zm.778-10c-3.667 0-6.667 3-6.667 6.667 0 3.666 3 6.666 6.667 6.666s6.667-3 6.667-6.666c0-3.667-3-6.667-6.667-6.667",
  fill: "#125598"
})));
export default SvgInformationCircle;